import Axios from 'axios';

export default {
  getJson(url) {
    return new Promise((resolve, reject) => {
      Axios({
        method: 'get',
        url: url,
        dataType: "json",
        crossDomain: true,
        cache: false,
        headers: {
          'Cache-Control': 'no cache'
        },
        params: {
          timestamp: Date.now()
        }
      }).then(res => {
        resolve(res)
      }).catch(error => {
        resolve(error)
      })
    })
  }
}
